import { View, Icon } from '@/components'
import { AppIcon } from '@codeleap/styles'

export type IconCircleProps = {
  icon: AppIcon
  size: number
  color: string
  bgCircle: string
  bgIcon: string
}

export const IconCircle = (props: IconCircleProps) => {
  const { icon, size, bgIcon, bgCircle, color } = props

  const wrapperPadding = size * 0.25
  const innerWrapperPadding = size * 0.43

  return (
    <View style={['center', 'br:infinite', { background: bgCircle, padding: wrapperPadding }]}>
      <View style={['center', 'br:infinite', { background: bgIcon, padding: innerWrapperPadding }]}>
        <Icon color={color} size={size} name={icon} />
      </View>
    </View>
  )
}
